// extracted by mini-css-extract-plugin
module.exports = {"arrow-up":"arrow_arrow-up__3uPiC","arrow-down":"arrow_arrow-down__RQE9E","inverted":"arrow_inverted__3olHr"};